import {
  LayoutTemplate,
  Repeat,
  Target,
  Smartphone,
  Search,
  LifeBuoy,
  ArrowUpRight,
} from "lucide-react";
import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

const ICONS = [LayoutTemplate, Repeat, Target, Smartphone, Search, LifeBuoy];

export const Services = () => {
  const t = useT();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-[#F8FAFC] border-y border-slate-200/60"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
              {t.services.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A2342] tracking-tight leading-[1.1]">
              {t.services.title}
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">
              {t.services.body}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || LayoutTemplate;
            return (
              <Reveal key={s.title} delay={70 * i}>
                <article
                  data-testid={`service-card-${i}`}
                  className="group relative bg-white rounded-2xl p-8 border border-slate-200/70 uv-card-hover h-full"
                >
                  <div className="flex items-start justify-between">
                    <span className="inline-flex w-12 h-12 items-center justify-center rounded-xl bg-[#2563EB]/10 text-[#2563EB] group-hover:bg-[#2563EB] group-hover:text-white transition-colors">
                      <Icon className="w-5 h-5" strokeWidth={2} />
                    </span>
                    <ArrowUpRight className="w-5 h-5 text-slate-300 group-hover:text-[#2563EB] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  </div>
                  <h3 className="mt-6 text-lg font-bold text-[#0A2342] leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                    {s.desc}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
